var __rspack_ns_object = JSON.parse('{"error.deletionFailed":"Failed to delete entity"}')